import { get, post, download } from './request'

export let paginateBookings = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let load = (booking, success, failure) => get(
  `api/booking/${booking}`, success, failure
)

export let approve = (booking, success, failure) => post(
  `api/booking/${booking.id}/approve`, booking, success, failure
)

export let reject = (booking, success, failure) => post(
  `api/booking/${booking.id}/reject`, booking, success, failure
)

export let remind = (booking, success, failure) => post(
  `api/booking/${booking.id}/remind`, booking, success, failure
)

export let captureOfflinePayment = (booking, success, failure) => post(
  `api/booking/${booking.id}/capture/off-line/payment`, booking, success, failure
)

export let downloadInvoice = (booking, success, failure) => download(
  `api/booking/${booking.id}/invoice`, success, failure
)

export let editBooking = (booking, success, failure) => post(
  `api/booking/${booking.id}/edit`, booking, success, failure
)

export let removeSlot = (booking, slot, success, failure) => post(
  `api/booking/${booking.id}/slot/${slot.id}/remove`, slot, success, failure
)

export let assignAdditionalBilling = (booking, items, success, failure) => post(
  `api/booking/${booking.id}/additional-billing/assign`, items, success, failure
)

export let downloadAddBillingInvoice = (booking, success, failure) => download(
  `api/booking/${booking.id}/additional-billing/invoice`, success, failure
)

export let remindAddBilling = (booking, success, failure) => post(
  `api/booking/${booking.id}/additional-billing/remind`, booking, success, failure
)

export let captureAdditionalBillingPayment = (booking, success, failure) => post(
  `api/booking/${booking.id}/capture/additional-billing/payment`, booking, success, failure
)

export let downloadFilteredExport = (params, success, failure) => download(
  `api/booking/filtered/export`, success, failure, { params }
)

export let deleteDeposit = ({ booking, deposit }, success, failure) => post(
  `api/booking/${booking}/deposit/${deposit}/delete`, {}, success, failure
)
